import { BdaModel, BdaModelDTO } from "../models/BdaModel";
import { KrakendCollection, PagedResults } from "../models/generics";
import client from "./axios";

const modelsUrl = `${window.__env.KRAKEND_URL}/v1/models`;
const servingUrl = `${window.__env.EVENT_GATEWAY_URL}/model`;

export interface ModelDeploySettings {
  replicasNumber: number;
  cpuLimit: string;
  memoryLimit: string;
}

export interface ModelDeploymentStatus {
  ready: boolean;
  label: string;
}

export const Models = {
  getModels: (params?: URLSearchParams) => client.get<PagedResults<BdaModel> | KrakendCollection<BdaModel>>(modelsUrl, { params }),
  getModel: (id: number, params?: URLSearchParams) => client.get<BdaModel>(`${modelsUrl}/${id}`, { params }),
  deleteModel: (id: number, params?: URLSearchParams) => client.delete(`${modelsUrl}/${id}`, { params }),
  downloadModel: (id: number) => client.get(`${modelsUrl}/${id}/export`, { responseType: 'blob' }),
  deployModel: (id: number, settings?: ModelDeploySettings) => client.post(`${modelsUrl}/${id}/serve`, settings),
  stopModel: (id: number) => client.delete(`${modelsUrl}/${id}/serve`),
  getModelStatus: (id: number) => client.get<ModelDeploymentStatus>(`${servingUrl}/${id}/ready`),
  getModelInfo: (id: number) => client.get<Record<string, any>>(`${modelsUrl}/${id}/info`),
  getModelMetadata: (id: number) => client.get<Record<string, any>>(`${servingUrl}/${id}`),
  createModel: (model: BdaModelDTO) => client.post(modelsUrl, model),
  updateModel: (model: BdaModelDTO) => client.post(`${modelsUrl}/${model.id}`, model),
  getModelsFormats: () => client.get<string[]>(`${modelsUrl}/formats`),
}